import { graphql } from '@/gql';

import './GroceryStoreFragment';

graphql(`
  fragment GroceriesFragment on GroceryType {
    id
    name
    orderId
    cartId
    orderUUId
    callerId
    customerName
    timeZone
    email
    address
    streetAddress
    streetAddress2
    city
    state
    zip
    country
    latitude
    longitude
    status
    currency
    notes
    orderNotes
    transactionId
    instruction
    userId
    orderedByName
    timeReceived
    timeShopping
    timeShoppingComplete
    timeInTransit
    timeCompleted
    timeCanceled
    paidStatus
    canceledBy
    canceledById
    canceledByName
    reasonForCanceling
    noGoGoFee
    noGoGoFeeReason
    tip
    totalCost
    gogoFee
    gogoCost
    discount
    isTipable
    ebtCost
    icTotalCost
    isSavedGrocery
    assignedOperatorId
    isConfirmedAddressAndNotes
    isInteractedWithShopper
    preauthChargeAmount
    driverId
    groceryStoreId
    storeName
    storeLogo
    driverName
    initialEstimateStartAt
    initialEstimateEndAt
    estimateStartAt
    estimateEndAt
    chatLink
    createdAt
    store {
      ...GroceryStore
    }
    driver {
      id
      firstName
      photo
    }
    storeItems {
      groceryId
      groceryItemId
      productName
      status
      qty
      initialQty
      deliveredQty
      refundedQty
      weight
      initialWeight
      deliveredWeight
      refundedWeight
      totalPrice
      finalPrice
      finalTotalPrice
      discountedPrice
      replacementItemId
      replacementItemQty
      instruction
      createdAt
      updatedAt
      initialCharge
      replacementPolicy
      groceryItem {
        id
        name
        img
        unit
        size
        price
        productId
        productName
        createdAt
        updatedAt
        itemId
        groceryProduct {
          id
          name
          createdAt
          updatedAt
        }
      }
      replacementItem {
        id
        name
        img
        unit
        size
        price
        productId
        productName
        createdAt
        updatedAt
        itemId
        groceryProduct {
          id
          name
          createdAt
          updatedAt
        }
      }
      replacedItem {
        id
        name
        img
        unit
        size
        price
        productId
        productName
        createdAt
        updatedAt
        itemId
        groceryProduct {
          id
          name
          createdAt
          updatedAt
        }
      }
    }
    needLoves {
      id
      groceryId
      operatorId
      type
      status
      resolution
      slackThreadUrl
      fields {
        name
        value
      }
      comments {
        name
        comment
        createdAt
      }
      createdAt
      updatedAt
      operator {
        id
        firstName
        lastName
      }
      reportedUserType
      reportedUser {
        id
        firstName
        lastName
      }
      resolvedOperator {
        id
        firstName
        lastName
      }
      assignedOperator {
        id
        firstName
        lastName
      }
    }
    assignedOperator {
      id
      firstName
      lastName
    }
  }
`);
